import { createRef, useEffect, useState } from "react"

import { DYNAMIC_OPTIONS, MATCH_RGX, revertInterpolated } from "./utils"
import { css, cx } from "@emotion/css"
import { queryCache, useMutation } from "react-query"

import { ApiError } from "api/http/utils"
import { EditableInterpolatedText } from "./EditableInterpolatedText"
import Surface from "components/Surface"
import { patchCurrentMarket } from "api/markets"
import { useFeedback } from "components/FeedbackSnackbar"
import { useI18n } from "providers/I18n"

type Props = {
  marketId: string
  marketTaxExempt?: string
}

export function TaxExempt(props: Props) {
  const { t } = useI18n()
  const { marketId, marketTaxExempt = "" } = props
  const sendFeedback = useFeedback((s) => s.send)
  const [taxExempt, setTaxExempt] = useState<string>(() => marketTaxExempt)
  const textRef = createRef<HTMLDivElement>()

  const [patch] = useMutation(patchCurrentMarket, {
    onSuccess: () => queryCache.invalidateQueries(["current-market"]),
    onError: (e: ApiError) => {
      const error = e as ApiError
      sendFeedback(error.message, "error")
    },
  })

  const handleBlur = () => {
    const u = textRef.current?.innerText
    if (u) {
      const r = revertInterpolated(u, DYNAMIC_OPTIONS)
      setTaxExempt(r)
      patch({ id: marketId, taxExempt: r })
    }
  }

  const onUpdate = (s: string) => {
    const r = revertInterpolated(s, DYNAMIC_OPTIONS)
    setTaxExempt(r)
    patch({ id: marketId, taxExempt: r })
  }

  useEffect(() => {
    setTaxExempt(() => marketTaxExempt)
  }, [marketTaxExempt])

  return (
    <Surface className={styles.surface}>
      <h5 className={cx(styles.header, "BodyBody-1BlackBold")}>
        {t("market.tax.exempt.header")}
      </h5>
      <div className={styles.end}></div>
      <EditableInterpolatedText
        ref={textRef}
        value={taxExempt}
        addBtnText={t("add.dynamic.content")}
        match={MATCH_RGX}
        options={DYNAMIC_OPTIONS}
        onBlur={handleBlur}
        onUpdate={onUpdate}
      />
    </Surface>
  )
}

const styles = {
  surface: css`
    padding: var(--spacing-xxl-2) var(--spacing-m) 0px;
  `,
  header: css`
    padding: var(--spacing-m) 0;
  `,
  end: css`
    display: flex;
    align-items: center;
    justify-content: end;
  `,
}
